import "./TopNav.css";
import Button from "./Button";
import { ReactComponent as DownArrow } from "./static/icons/DownArrow.svg";
import { ReactComponent as MenuIcon } from "./static/icons/MenuIcon.svg";
import { goToElement } from "./LeftNavButton";
import { goToPage } from "./Slide";

function TopNav({ openMenu }) {
  var MenuButton = (
    <Button
      variant="complex"
      text="CONTACT ME"
      icon={<DownArrow />}
      onClick={() => goToElement(5)}
    />
  );
  if (window.location.pathname !== "/") {
    MenuButton = (
      <Button
        variant="complex"
        text="MENU"
        icon={<MenuIcon />}
        onClick={openMenu}
      />
    );
  }
  return (
    <div className="TopNav">
      <span
        className="Logo"
        onClick={() => {
          if (window.location.pathname === "/") goToElement(0);
          else goToPage("/");
        }}
      >
        frosteffy
      </span>
      <span>PORTFOLIO</span>
      {MenuButton}
    </div>
  );
}
export default TopNav;
